/**
 * RFC 4122 v4 UUID generator that works in both secure and insecure contexts.
 *
 * `crypto.randomUUID()` is only available in secure contexts (HTTPS, localhost).
 * On insecure origins (e.g. `http://192.168.x.x`) it is `undefined` and calling
 * it throws `TypeError`. This helper falls back to `crypto.getRandomValues()`
 * which IS available in insecure contexts.
 */
export function uuidV4(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function')
    return crypto.randomUUID();

  // crypto.getRandomValues is available in all browser contexts (including insecure).
  // If crypto is entirely missing (e.g. very old Node without globals), fall back to Math.random.
  const b = new Uint8Array(16);
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.getRandomValues === 'function'
  ) {
    crypto.getRandomValues(b);
  } else {
    for (let i = 0; i < 16; i++) b[i] = (Math.random() * 256) >>> 0;
  }
  // Set version (4) and variant (RFC 4122)
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, x => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
